import React from 'react';
import { CompaniesRow, DrawingsRow, RecordTypesRow } from './components/rows'

export const getChecklistResults = (data) => {
  return [
    isCompaniesOnProject(data),
    isMatrakNotOnProject(data),
    hasProjectGotDrawings(data),
    hasNoDrawingsWithoutOverlays(data),
    hasRecordTypes(data),
    hasMaterialRecordTypes(data),
    hasContainerRecordTypes(data),
    hasLocationRecordTypes(data),
    hasTaskRecordTypes(data),
    hasNoListsWithoutListValues(data),
    hasCompaniesGotReports(data)
  ];
};

export const isCompaniesOnProject = (data) => {
  let value = data.Project.companies.length;
  return {
    criteria: '# of companies on project',
    requirement: '>0',
    value,
    status: value > 0 ? 'GOOD' : 'BAD',
    companies: data.Project.companies,
    override: value ? (props) => (<CompaniesRow row={props} title='Companies On Project'/>) : null,
  };
};

export const hasCompaniesGotReports = (data) => {
  const filteredCompanies = data.Project.companies.filter(c => !c.reportTemplates.length);
  const value = filteredCompanies.length;
  const totalCompanies = data.Project.companies.length;
  return {
    criteria: 'All companies have reports',
    requirement: '100%',
    value: `${totalCompanies - value}/${totalCompanies}`,
    status: !value ? 'GOOD' : 'BAD',
    companies: filteredCompanies,
    override: value ? (props) => (<CompaniesRow row={props} title='Companies Without Reports'/>) : null,
  };
};

export const isMatrakNotOnProject = (data) => {
  const companiesExcludingMatrak = data.Project.companies.filter(c => c.name === 'Matrak');
  let value = companiesExcludingMatrak.length === 0;
  return {
    criteria: 'Matrak is not a company on the project',
    requirement: 'TRUE',
    value: value ? 'TRUE' : 'FALSE',
    status: value ? 'GOOD' : 'BAD'
  };
};

export const hasProjectGotDrawings = (data) => {
  let drawings = data.allDrawings;
  let value = drawings.length;
  return {
    criteria: '# of drawings on project',
    requirement: '>0',
    value: value > 999 ? '+1000' : value,
    status: value > 0 ? 'GOOD' : 'BAD',
    drawings,
    override: value ? (props) => (<DrawingsRow row={props} title='Drawings On Project'/>) : null,
  };
};

export const hasNoDrawingsWithoutOverlays = (data) => {
  const drawingsWithoutOverlays = data.allDrawings.filter(d => d.overlays.length === 0);
  let value = drawingsWithoutOverlays.length;
  return {
    criteria: 'No drawings without overlays',
    requirement: '0',
    value,
    status: value === 0 ? 'GOOD' : 'BAD',
    drawings: drawingsWithoutOverlays,
    override: value ? (props) => (<DrawingsRow row={props} title='Drawings Without Overlays'/>) : null,
  };
};

export const hasRecordTypes = (data) => {
  let value = data.allRecordTypes.length;
  return {
    criteria: '# of record types',
    requirement: '>1',
    value,
    status: value > 1 ? 'GOOD' : 'BAD',
    recordTypes: data.allRecordTypes,
    override: value ? (props) => (<RecordTypesRow row={props} title='Record Types On Project'/>) : null,
  };
};

export const hasMaterialRecordTypes = (data) => {
  const filteredRecordTypes = data.allRecordTypes.filter(c => c.category === 'material');
  let value = filteredRecordTypes.length;
  return {
    criteria: '# of record types of category "material"',
    requirement: '>1',
    value,
    status: value > 1 ? 'GOOD' : 'BAD',
    recordTypes: filteredRecordTypes,
    override: value ? (props) => (<RecordTypesRow row={props} title='Material Record Types'/>) : null,
  };
};

export const hasContainerRecordTypes = (data) => {
  const filteredRecordTypes = data.allRecordTypes.filter(c => c.category === 'container');
  let value = filteredRecordTypes.length;
  return {
    criteria: '# of record types of category "container"',
    requirement: '>1',
    value,
    status: value > 1 ? 'GOOD' : 'BAD',
    recordTypes: filteredRecordTypes,
    override: value ? (props) => (<RecordTypesRow row={props} title='Container Record Types'/>) : null,
  };
};

export const hasLocationRecordTypes = (data) => {
  const filteredRecordTypes = data.allRecordTypes.filter(c => c.category === 'location');
  let value = filteredRecordTypes.length;
  return {
    criteria: '# of record types of category "location"',
    requirement: 'No requirement',
    value,
    status: 'GOOD',
    recordTypes: filteredRecordTypes,
    override: value ? (props) => (<RecordTypesRow row={props} title='Location Record Types'/>) : null,
  };
};

export const hasTaskRecordTypes = (data) => {
  const filteredRecordTypes = data.allRecordTypes.filter(c => c.category === 'task');
  let value = filteredRecordTypes.length;
  return {
    criteria: '# of record types of category "task"',
    requirement: 'No requirement',
    value,
    status: 'GOOD',
    recordTypes: filteredRecordTypes,
    override: value ? (props) => (<RecordTypesRow row={props} title='Task Record Types'/>) : null,
  };
};

export const hasNoListsWithoutListValues = (data) => {
  let badLists = [];
  for (let r of data.allRecordTypes) {
    badLists = [...badLists, ...r.descriptions.filter(d => ['list', 'button-list'].includes(d.type) && d.listValues.length === 0)];
  }
  let value = badLists.length;
  return {
    criteria: 'No lists without list values',
    requirement: '0',
    value,
    status: value === 0 ? 'GOOD' : 'BAD'
  };
};

